import { Menu } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { Sheet } from "@themes/pollinator/ui/Sheet";
import { PollinatorLogo } from "@themes/pollinator/ui/PollinatorLogo";
import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";

export type Props = {
  // navigation items component
  children: React.ReactNode;
  isMobileMenuOpen: boolean;
  openMobileMenu: () => void;
  closeMobileMenu: () => void;
};

export function MarketingHeader({
  children,
  isMobileMenuOpen,
  openMobileMenu,
  closeMobileMenu,
}: Props) {
  return (
    <OuterContentContainer
      as="header"
      className="border-b border-brand-800"
      innerClassName="w-full justify-between"
    >
      <div className="flex items-center justify-between py-8 w-full md:py-4">
        <a
          href="/"
          data-testid="marketing-header-home"
          title="Home"
          aria-label="Home"
          className="with-ring focus:rounded-lg focus:ring-offset-[16px]"
        >
          <PollinatorLogo size="lg" className="hidden md:block" />
          <PollinatorLogo size="md" className="block md:hidden" />
        </a>

        {/* DESKTOP NAVIGATION */}
        <div className="hidden w-full justify-between gap-2 md:flex">
          {children}
        </div>

        {/* MOBILE NAVIGATION */}
        <Button
          variant="ghost"
          iconComponent={Menu}
          className="size-max md:hidden"
          onClick={openMobileMenu}
          data-testid="marketing-header-mobile-menu-open"
        />
        <Sheet isOpen={isMobileMenuOpen} onClose={closeMobileMenu}>
          {children}
        </Sheet>
      </div>
    </OuterContentContainer>
  );
}

export default MarketingHeader;

